// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"promo_textWrapper__2o_d0","mainText":"promo_mainText__2a4lO","logoPromo":"promo_logoPromo__2MhFu","hot":"promo_hot__yXwLK","textCenter":"promo_textCenter__17kLO"};